export default {
  AC: "AC",
  DC: "DC",
  AC_AND_DC: "AC et DC",
}
